export type LogLevel = "INFO" | "WARNING" | "ERROR";

function formatException(exception?: unknown): string {
    if (exception == null) {
        return "";
    }

    if (exception instanceof Error) {
        return ` | ${exception.name}: ${exception.message}`;
    }

    if (typeof exception === "string") {
        return ` | ${exception}`;
    }

    try {
        return ` | ${JSON.stringify(exception)}`;
    } catch {
        return ` | ${String(exception)}`;
    }
}

export class Logger {
    constructor(private readonly scope: string) {}

    info(message: string): void {
        this.log("INFO", message);
    }

    warning(message: string, exception?: unknown): void {
        this.log("WARNING", message, exception);
    }

    error(message: string, exception?: unknown): void {
        this.log("ERROR", message, exception);
    }

    private log(level: LogLevel, message: string, exception?: unknown): void {
        const formattedMessage = `[${level}] [${this.scope}] ${message}${formatException(exception)}`;

        if (level === "ERROR") {
            console.error(formattedMessage);
            return;
        }

        if (level === "WARNING") {
            console.warn(formattedMessage);
            return;
        }

        console.info(formattedMessage);
    }
}

export function createLogger(scope: string): Logger {
    return new Logger(scope);
}
